"use client"

import { AirVent } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `AirVentIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const AirVentIcon = component(Icon)({ as: AirVent })
